// https://stackoverflow.com/questions/154059/how-do-i-check-for-an-empty-undefined-null-string-in-javascript 를 참고
export const isEmptyString = (value: string | undefined) => !value || value === '';
